// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadLogo_uploadBox__1BMax {
  width: fit-content;
  padding: 10px 12px;
  border: 2px dashed var(--brand);
  border-radius: 8px;
  background-color: #F2F6F8;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}
.UploadLogo_uploadBox__1BMax:hover {
  background-color: var(--light-gray);
}

.UploadLogo_hiddenInput__ZXrnM {
  display: none;
}

.UploadLogo_content__G34Um {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--primary-Text);
  font: var(--body-font-three);
  font-weight: 500;
}
.UploadLogo_content__G34Um img {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/UploadLogo/UploadLogo.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;AACJ;AACI;EACI,mCAAA;AACR;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,0BAAA;EACA,4BAAA;EACA,gBAAA;AAAJ;AAEI;EACI,WAAA;EACA,YAAA;AAAR","sourcesContent":[".uploadBox {\r\n    width: fit-content;\r\n    padding: 10px 12px;\r\n    border: 2px dashed var(--brand);\r\n    border-radius: 8px;\r\n    background-color: #F2F6F8;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: background 0.2s ease;\r\n\r\n    &:hover {\r\n        background-color: var(--light-gray);\r\n    }\r\n}\r\n\r\n.hiddenInput {\r\n    display: none;\r\n}\r\n\r\n.content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    color: var(--primary-Text);\r\n    font: var(--body-font-three);\r\n    font-weight: 500;\r\n\r\n    img {\r\n        width: 16px;\r\n        height: 16px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uploadBox": `UploadLogo_uploadBox__1BMax`,
	"hiddenInput": `UploadLogo_hiddenInput__ZXrnM`,
	"content": `UploadLogo_content__G34Um`
};
export default ___CSS_LOADER_EXPORT___;
